import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mobile',
    template: `
      <div class="app-mobile"></div>
  `,
    styleUrls: ['./mobile.component.scss'],
    standalone: false
})
export class MobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}
